import axios from 'axios';
import { SerializedError } from '@reduxjs/toolkit';

const SERIALIZED_ERROR_FIELDS = ['name', 'message', 'stack', 'code'];

/**
 * An error that was already serialized - e.g. the rejection of a nested thunk re-thrown by
 * unwrap(). It is a plain object, so it has to be recognised by its fields.
 */
export const isSerializedError = (error: unknown): error is SerializedError =>
  typeof error === 'object' &&
  error !== null &&
  !(error instanceof Error) &&
  !axios.isAxiosError(error) &&
  SERIALIZED_ERROR_FIELDS.some(
    field => typeof (error as Record<string, unknown>)[field] === 'string',
  );
